import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'search',
  standalone: false,
})
export class SearchPipe implements PipeTransform {
  transform(items: any[], searchText: string): any[] {
    if (!items) {
      return [];
    }
    if (!searchText) {
      return items;
    }
    searchText = searchText.toLowerCase();
    return items.filter(item => {
      return (
        String(item.firstName).toLowerCase().includes(searchText) ||
        String(item.lastName).toLowerCase().includes(searchText) ||
        String(item.emailAddress).toLowerCase().includes(searchText)
      );
    });
  }
}
